<template>
  <h2 class="text-primary-600 text-base! font-medium!">
    <slot name="default">
      <i18n-t v-if="keypath" :keypath="keypath" />
    </slot>
  </h2>
</template>

<script setup lang="ts">
  import { toRef } from "vue"
  import { useI18n } from "vue-i18n"

  interface Slots {
    /**
     * Heading Content
     */
    default(): never
  }

  defineSlots<Slots>()

  interface Props {
    /**
     * Lookup heading content from i18n
     */
    keypath?: string
  }

  const props = defineProps<Props>()
  const keypath = toRef(props, "keypath")

  useI18n({ useScope: "parent" })
</script>
